import styled from "styled-components";

import { FooterComponent } from "app/components/widget/WidgetFooter";
import { useSocialTrafficContext } from "app/pages/website-analysis/social-overview/socialTraffic/context";
import { FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import { devicesTypes } from "app/UtilitiesAndConstants/Constants/DevicesTypes";
import { allTrackers } from "app/services/track/track";

const Container = styled(FlexColumn)`
    height: 50px;
    justify-content: center;
    align-items: flex-end;
    padding-right: 10px;
`;

export const Cta = ({ getCtaLink, unlockHook = null }) => {
    const { params } = useSocialTrafficContext();
    const ctaLink = getCtaLink({ ...params, webSource: devicesTypes.DESKTOP });
    const trackLink = () => {
        allTrackers.dispatchTrackEvent(
            "Internal Link",
            "click",
            "Bar Chart/Traffic Sources Overview/see full overview",
        );
    };

    return (
        <Container>
            <FooterComponent
                href={ctaLink.href}
                onClick={trackLink}
                text="wwo.traffic.sources.button"
                unlockHook={unlockHook}
                target={ctaLink.target}
            />
        </Container>
    );
};
